$(function () {
  'use strict';

  function postEventLog(page, target, action) {
    $.ajax({
      type: 'POST',
      url: '/api/v1/event_logs',
      data: {
        event_log: {
          page: page,
          target: target,
          action: action,
        }
      }
    });
  }

 // イベントの記録
  // 計測したい対象要素に、イベント毎のclassと以下のdata属性を付与
  // ```
  // data-page="<ページを識別する名前>"
  // data-target="<操作対象を識別する名前>"
  // ```

  // クリックイベント
  // ```
  // class="js-event-logger"
  // ```
  $.each($('.js-event-logger'), function() {
    const page = $(this).data('page');
    const target = $(this).data('target');
    $(this).on('click', function() {
      postEventLog(page, target, 'click');
    });
  });

  // showイベント
  // ```
  // class="js-event-logger-show"
  // ```
  $.each($('.js-event-logger-show'), function() {
    const page = $(this).data('page');
    const target = $(this).data('target');
    postEventLog(page, target, 'show');
  });

});
